import React, { Component } from 'react';
import Portfolio from './components/Portfolio/Portfolio';

class App extends Component {
  render() {
    return (
      <div>
        <Portfolio />
      </div>
    );
  }
}

export default App;
